import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Target, Zap } from 'lucide-react';

const GameHUD = ({ score, combo, accuracy, timer }) => {
  return (
    <div className="absolute inset-0 pointer-events-none" data-testid="game-hud">
      <div className="absolute top-6 left-6 bg-black/60 backdrop-blur-xl border border-primary/30 rounded-xl p-4">
        <div className="flex items-center gap-2 mb-2">
          <Trophy className="w-5 h-5 text-accent" />
          <span className="text-xs text-muted-foreground font-semibold uppercase tracking-wider">Score</span>
        </div>
        <motion.div
          key={score}
          initial={{ scale: 1.2 }}
          animate={{ scale: 1 }}
          className="text-4xl font-heading font-black text-accent"
        >
          {score}
        </motion.div>
      </div>

      {combo > 0 && (
        <motion.div
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          className="absolute top-6 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-secondary/80 to-primary/80 backdrop-blur-xl border border-white/20 rounded-lg px-6 py-3"
        >
          <div className="flex items-center gap-2">
            <Zap className="w-5 h-5 text-white" />
            <span className="text-2xl font-heading font-black text-white">COMBO x{combo}</span>
          </div>
        </motion.div>
      )}

      <div className="absolute top-6 right-6 bg-black/60 backdrop-blur-xl border border-primary/30 rounded-xl p-4">
        <div className="flex items-center gap-2 mb-2">
          <Target className="w-5 h-5 text-primary" />
          <span className="text-xs text-muted-foreground font-semibold uppercase tracking-wider">Accuracy</span>
        </div>
        <div className="text-3xl font-heading font-black text-primary">
          {accuracy.toFixed(0)}%
        </div>
      </div>

      {timer !== null && (
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 bg-black/80 backdrop-blur-xl border border-border rounded-full px-8 py-4">
          <div className="text-3xl font-heading font-black text-foreground">
            {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')}
          </div>
        </div>
      )}
    </div>
  );
};

export default GameHUD;
